export const EverouDeveloper = ({
    uid,
    email,
    name,
} = {}) => ({
    uid,
    email,
    name,
});